import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { BrandMark } from './BrandMark';
const navLinks = [{
  name: 'Servicios',
  href: '/servicios'
}, {
  name: 'Proceso',
  href: '/proceso'
}, {
  name: 'Enfoque',
  href: '/resultados'
}, {
  name: 'FAQ',
  href: '/faq'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/95 backdrop-blur-md transition-[padding] duration-200 ${isScrolled ? 'py-3' : 'py-4'}`} data-id="element-55" data-mp="9ozhakqrm20h">
      <div className="container mx-auto flex items-center justify-between px-6 md:px-12" data-id="element-56" data-mp="jmx371l5jmpx">
        <Link to="/" className="relative z-50 inline-flex items-center gap-3 text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" aria-label="Growthly, inicio" data-id="element-57" data-mp="olqj10nwvpt9">
          <span className="flex h-9 w-9 items-center justify-center border border-white/25 text-white" data-id="element-58" data-mp="3s049f917k4l2">
            <BrandMark size={18} data-id="element-59" data-mp="5mw0dglbu57t" />
          </span>
          <span className="text-[13px] font-semibold tracking-[0.16em]" data-id="element-60" data-mp="5nnxwwyhid0q">
            GROWTHLY
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Navegación principal" data-id="element-61" data-mp="34cmh9ce174hk">
          {navLinks.map(link => {
          const isActive = location.pathname === link.href;
          return <Link key={link.href} to={link.href} aria-current={isActive ? 'page' : undefined} className={`relative px-3 py-2 text-[12px] font-medium tracking-wide transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white ${isActive ? 'text-white' : 'text-neutral-400 hover:text-white'}`} data-id="element-62" data-mp="2wcq7cdrvrk8k">
                {link.name}
                {isActive && <motion.span layoutId="nav-indicator" className="absolute inset-x-3 bottom-0 h-px bg-white" transition={{
              type: 'spring',
              stiffness: 450,
              damping: 38
            }} data-id="element-63" data-mp="2dff9mxlwcyv8" />}
              </Link>;
        })}
          <Link to="/contacto" className="ml-4 px-3 py-2 text-[12px] font-medium tracking-wide text-neutral-300 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-64" data-mp="2ndod772cej4">
            Contacto
          </Link>
          <Link to="/checkout" className="ml-3 inline-flex items-center gap-2 bg-white px-4 py-2.5 text-[12px] font-semibold text-black transition-colors hover:bg-neutral-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-65" data-mp="15x7sdczph2d">
            Empezar <ArrowUpRightIcon size={14} aria-hidden="true" data-id="element-66" data-mp="k38881acygje" />
          </Link>
        </nav>

        <button type="button" className="relative z-50 inline-flex h-10 w-10 items-center justify-center border border-white/15 text-white transition-colors hover:border-white/40 lg:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-white" onClick={() => setIsMobileMenuOpen(isOpen => !isOpen)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} data-id="element-67" data-mp="o4blcg10tygx">
          {isMobileMenuOpen ? <XIcon size={19} data-id="element-68" data-mp="3k56v6cv0jmm4" /> : <MenuIcon size={19} data-id="element-69" data-mp="3f37td7ex8xra" />}
        </button>

        <AnimatePresence data-id="element-70" data-mp="3f4156msqmdga">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -12
        }} transition={{
          duration: 0.22,
          ease: 'easeOut'
        }} className="absolute inset-x-0 top-0 min-h-screen bg-black px-6 pb-10 pt-28 lg:hidden" data-id="element-71" data-mp="3b2xq42iiklg4">
              <nav aria-label="Navegación móvil" data-id="element-72" data-mp="uf3bsrrx3905">
                <ul className="border-t border-white/10" data-id="element-73" data-mp="pn21hbeb7scr">
                  {[{
                name: 'Inicio',
                href: '/'
              }, ...navLinks, {
                name: 'Contacto',
                href: '/contacto'
              }].map(link => <li key={link.href} className="border-b border-white/10" data-id="element-74" data-mp="2m9ba9iydha3d">
                      <Link to={link.href} aria-current={location.pathname === link.href ? 'page' : undefined} className="flex items-center justify-between py-5 text-xl font-medium tracking-tight text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-75" data-mp="2m78gcnu3mwtd">
                        {link.name}
                        <ArrowUpRightIcon size={18} aria-hidden="true" data-id="element-76" data-mp="39zymuhj8gnw9" />
                      </Link>
                    </li>)}
                </ul>
              </nav>
              <Link to="/checkout" className="mt-8 flex items-center justify-center gap-2 bg-white px-5 py-4 text-sm font-semibold text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-77" data-mp="1euzb8z1o07da">
                Iniciar mi proyecto{' '}
                <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-78" data-mp="1jt0sdefj5wm4" />
              </Link>
              <p className="mt-4 text-center text-xs text-neutral-500" data-id="element-79" data-mp="1xkfevv8ncfxx">
                Oferta única · 350€ · Sin cuotas
              </p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}